'use client';

import { Contact } from '@/components/contact';
import { HeroBlock } from '@/features/projects/blocks/hero/hero-block';
import { ProjectsBlock } from '@/features/projects/blocks/project/projects-block';
import { MainLayout } from '@/layouts/main';
import Head from 'next/head';
import { generateNextSeo } from 'next-seo/pages';
import type { FC } from 'react';

type ProjectsPageClientProps = {
  locale: string;
};

export const ProjectsPage: FC<ProjectsPageClientProps> = ({ locale }) => {
  return (
    <>
      <Head>{generateNextSeo({
        title: `Projects - ${locale}`,
        description: `Our projects - ${locale}`
      })}</Head>
      <MainLayout>
        <div className="bg-[#0A0A0A] relative">
          <HeroBlock />
          <ProjectsBlock />
          <Contact />
        </div>
      </MainLayout>
    </>
  );
};
